// extracted by mini-css-extract-plugin
module.exports = {"Logo":"SparkPost_Logo__QvKOc","Icon":"SparkPost_Icon__aVol6"};